<template>
  <div>
    <div class="row" style="padding-bottom: 10px">
      <div class="col-md-2">
        <label for="startDate">{{$t('Tarixdən')}}</label>
        <el-date-picker size="small" id="startDate" format="dd.MM.yyyy" type="date" :clearable="false"
          v-model="item.startDate">
        </el-date-picker>
      </div>
      <div class="col-md-2">
        <label for="endDate">{{$t('Tarixədək')}}</label>
        <el-date-picker size="small" id="endDate" format="dd.MM.yyyy" type="date" :clearable="false"
          v-model="item.endDate">
        </el-date-picker>
      </div>
      <div class="col-md-8" style="padding-bottom: 10px">
       <label>{{$t('Axtarış_növü')}}</label>
        <div class="d-flex justify-content-start">
          <div class="d-flex flex-row">
            <el-select style="width: 90%" @change="item.searchText = ''" size="small" v-model="item.searchType">
              <el-option :label="$t('--_Bütün_--')" :value="0"></el-option>
              <el-option :label="$t('Hadisə_nömrəsi')" :value="1"></el-option>
              <el-option :label="$t('Məsul_şəxs')" :value="2"></el-option>
              <el-option :label="$t('İştirakçılara_görə')" :value="3"></el-option>
            </el-select>
            &nbsp;
            <el-input size="small" :placeholder="$t('Axtar')" :disabled="item.searchType == 0" v-model="item.searchText">
              <template slot="prepend"> </template>
            </el-input>
            &nbsp;
            <el-button size="small" :title="$t('Axtarış')" type="primary" icon="el-icon-search"
              @click="performSearch"></el-button>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Badge container moved here and styled to fit -->
    <div class="row">
      <div class="col-12">
        <div class="badge-container" style="display: flex; flex-wrap: wrap; gap: 5px; margin-bottom: 10px; justify-content: space-between;">
          <div class="el-badge item" style="flex: 1; min-width: 120px; max-width: 160px;">
            <el-button @click="setStatusTypeAndGetData(11)" size="small" class="button-width"
              :class="{ 'active-button': activeStatusType === 11 }">{{$t('Təsdiq_gözləyir')}}</el-button>
            <sup class="el-badge__content el-badge__content is-fixed" style="background-color: #FFA500;">{{
              totalRecordsByStatusType[11] || 0 }}</sup>
          </div>
          <div class="el-badge item" style="flex: 1; min-width: 120px; max-width: 160px;">
            <el-button size="small" @click="setStatusTypeAndGetData(5)" class="button-width"
              :class="{ 'active-button': activeStatusType === 5 }">{{$t('crası_başlamayıb')}}</el-button>
            <sup class="el-badge__content el-badge__content is-fixed" style="background-color:#808000;">{{
              totalRecordsByStatusType[5] || 0 }}</sup>
          </div>
          <div class="el-badge item" style="flex: 1; min-width: 120px; max-width: 160px;">
            <el-button size="small" @click="setStatusTypeAndGetData(10)" class="button-width"
              :class="{ 'active-button': activeStatusType === 10 }">{{$t('İcrada')}}</el-button>
            <sup class="el-badge__content el-badge__content is-fixed" style="background-color: #008000;">{{
              totalRecordsByStatusType[10] || 0 }}</sup>
          </div>
          <div class="el-badge item" style="flex: 1; min-width: 120px; max-width: 160px;">
            <el-button size="small" @click="setStatusTypeAndGetData(12)" class="button-width"
              :class="{ 'active-button': activeStatusType === 12 }">{{$t('Təyinat_dəyişdirilib')}}</el-button>
            <sup class="el-badge__content el-badge__content is-fixed" style="background-color:#FF0000;">{{
              totalRecordsByStatusType[12] || 0 }}</sup>
          </div>
          <div class="el-badge item" style="flex: 1; min-width: 120px; max-width: 160px;">
            <el-button size="small" @click="setStatusTypeAndGetData(13)" class="button-width"
              :class="{ 'active-button': activeStatusType === 13 }">{{$t('Tələbdən_imtina')}}</el-button>
            <sup class="el-badge__content el-badge__content is-fixed" style="background-color: #800000;">{{
              totalRecordsByStatusType[13] || 0 }} </sup>
          </div>
          <div class="el-badge item" style="flex: 1; min-width: 120px; max-width: 160px;">
            <el-button size="small" @click="setStatusTypeAndGetData(14)" class="button-width"
              :class="{ 'active-button': activeStatusType === 14 }">{{$t('Geri_qaytarılıb')}}</el-button>
            <sup class="el-badge__content el-badge__content is-fixed" style="background-color: #B3005E;">{{
              totalRecordsByStatusType[14] || 0 }}</sup>
          </div>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-12">
        <el-table v-loading="loading" :data="data.filter(
          (data) =>
            !search ||
            (data.dispAccidentNumber && data.dispAccidentNumber.toString().includes(search.toLowerCase())) ||
            (data.accidentCommUserName && data.accidentCommUserName.toLowerCase().includes(search.toLowerCase())) ||
            (data.participants.toString().toLowerCase().includes(search.toLowerCase()))
        )" style="width: 100%">
          <el-table-column :label="$t('Hadisə_#')" sortable prop="dispAccidentNumber" width="120">
            <template #default="scope">
              <span style="font-weight: bold">{{ scope.row.dispAccidentNumber }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('DQN')" sortable prop="regNumber" width="100">
          </el-table-column>
          <el-table-column :label="$t('Komissar')" sortable prop="accidentCommUserName" width="200">
          </el-table-column>
          <el-table-column :label="$t('Tarix')" width="200" sortable prop="statusDateStr">
          </el-table-column>
          <el-table-column :label="$t('Ərazi')" sortable prop="placeName">
          </el-table-column>

          <el-table-column :label="$t('Status')">
            <template slot-scope="scope">
              <status-label :type="scope.row.statusTypeId === 5 ? 'olive' : '' ||
                scope.row.statusTypeId === 10
                ? 'green' : '' ||
                  scope.row.statusTypeId === 11
                  ? 'orange' : '' ||
                    scope.row.statusTypeId === 12
                    ? 'red' : ''
                      ||
                      scope.row.statusTypeId === 13
                      ? 'darkred' : '' ||
                        scope.row.statusTypeId === 14
                        ? 'mixred' : ''" />
              {{ scope.row.statusTypeName }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" width="45">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-button :title="$t('Düzəliş')" @click="handleEdit(scope.row.id)" style="padding: 0 !important" size="large">
                <div class="square-icon">
                  <i class="fa-solid fa-up-right-from-square "></i>
                </div>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center">
          <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
            :current-page="pagination.currentPage" :page-sizes="[10, 30, 50, 100, 200]" :page-size="pagination.pageSize"
            layout="sizes, prev, pager, next " :total="pagination.total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DateToString, AddMonths, AddDays } from "../../services/helper";
import StatusLabel from "../components/StatusLabel.vue";
import { GetCommApprovals } from "src/services/accident";

export default {
  data() {
    return {
      totalRecordsByStatusType: [],
      loading: false,
      data: [],
      allData: [],
      search: "",
      item: {
        startDate: null,
        endDate: null,
        statusType: 5,
        searchType: 0, // Default value for searchType
        searchText: null,
        pageSize: 10,
        pageNumber: 1,
      },
      activeStatusType: null, // add this line
      uid: this.$store.state.user.id,
      statusTypes: [5, 10, 11, 12, 13, 14],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  components: {
    StatusLabel,
  },
  methods: {
    async getCounts() {
      this.totalRecordsByStatusType = {};

      for (const statusType of this.statusTypes) {
        const requestData = {
          startDate: DateToString(this.item.startDate),
          endDate: DateToString(this.item.endDate),
          statusType: statusType,
          searchType: this.item.searchType,
          searchText: this.item.searchText,
          pageSize: 1,
          pageNumber: 1,
        };

        const response = await GetCommApprovals(requestData);

        if (response && response.data.data && response.data.data?.[0]) {
          const statusTypeTotalRecords = response.data.data?.[0].totalRecords;
          this.totalRecordsByStatusType[statusType] = statusTypeTotalRecords;
        }
      }
    },

    async performSearch() {
      await this.getCounts();
      this.pagination.currentPage = 1;
      await this.getAllData();
    },
    async getAllData() {
      this.loading = true;

      const requestData = {
        startDate: DateToString(this.item.startDate),
        endDate: DateToString(this.item.endDate),
        statusType: this.activeStatusType,
        searchType: this.item.searchType,
        searchText: this.item.searchText,
        pageSize: this.pagination.pageSize,
        pageNumber: this.pagination.currentPage,
      };

      const response = await GetCommApprovals(requestData);

      if (response && response.data.data && response.data.data.length > 0) {
        this.data = response.data.data;
        if (response.data.data?.[0]) {
          this.pagination.total = response.data.data?.[0].totalRecords;
        }
      }
      else {
        this.data = [];
        this.pagination.total = 0; // Reset total if no data
      }

      this.loading = false;
    },

    handleSizeChange(pageSize) {
      this.pagination.pageSize = pageSize;
      this.pagination.currentPage = 1;
      this.getAllData();
    },
    handleCurrentChange(page) {
      this.pagination.currentPage = page;
      this.getAllData();
    },
    setStatusTypeAndGetData(statusType) {
      this.activeStatusType = statusType;
      this.pagination.currentPage = 1;
      this.getAllData();
    },

    handleEdit(id) {
      let routeData = this.$router.resolve({ path: "../comm/accident/" + id });
      window.open(routeData.href, "_blank");
    },
    loadTime() {
      this.item.startDate = AddMonths(new Date(), -6);
      this.item.endDate = AddDays(new Date(), +1);
    },
  },
  mounted() {
    this.loadTime();
    this.getCounts().then(() => {
      this.setStatusTypeAndGetData(11);
    });
  },
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

input[type="checkbox"] {
  pointer-events: none;
}

.badge-container {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-bottom: 10px;
}

.badge-container .item {
  flex: 1;
  min-width: 120px;
  max-width: 160px;
}

.button-width {
  width: 100%;
  white-space: normal;
  line-height: 1.2;
  padding: 8px 5px;
}

.el-badge__content {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  /* to position the badge at the top right corner */
}

.colorHexGreen .el-badge__content {
  background-color: #00ff00 !important;
}

.colorHexYellow .el-badge__content {
  background-color: #ffff00 !important;
}

.is-selected {
  background-color: #ccc;
}

.active-button {
  background-color: #007bff !important;
  color: white !important;
  border: none !important;
  transition: all 0.3s !important;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19) !important;
}
</style>
